import Layout from "@/layouts/layout";
import ReviewForm from "@/components/projects/ReviewForm";
import PageHeading from "@/components/layout/PageHeading";
import Panel from "@/components/ui/Panel";

import type { ProjectReview } from "@/interfaces/project_review";
import type { Project } from "@/interfaces/project";

export default function EditReview({
  review,
  project,
}: {
  review: ProjectReview;
  project: Project;
}) {
  return (
    <Layout>
      <div className="flex flex-col gap-6">
        <PageHeading
          eyebrow={project?.title ?? "Project"}
          title={`Review on ${new Date(review.created_at).toLocaleDateString()}`}
        />

        <Panel title="review.txt">
          <ReviewForm project={project} review={review} />
        </Panel>
      </div>
    </Layout>
  );
}
